export default __webpack_public_path__ + "static/media/topLandrangerBackground.396c516a.jpg";